// src/validation/auth.schema.js
import * as Yup from "yup";
import { parsePhoneNumberFromString } from "libphonenumber-js";

function isValidE164(value) {
  if (!value) return false;
  const phone = parsePhoneNumberFromString(value);
  return phone && phone.isValid();
}

export const signupSchema = Yup.object({
  fullName: Yup.string()
    .required("Full name is required")
    .min(3, "Full name must be at least 3 characters")
    .max(50, "Full name must be at most 50 characters"),

  email: Yup.string()
    .email("Enter a valid email")
    .required("Email is required"),

  phone: Yup.string()
    .required("Phone number is required")
    .test(
      "is-valid-phone",
      "Enter a valid phone number with country code",
      isValidE164
    ),

  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

export const loginSchema = Yup.object({
  email: Yup.string()
    .email("Enter a valid email")
    .required("Email is required"),

  password: Yup.string().required("Password is required"),
});
